<template>
  <div>
    <strong style="font-size: 18px">Order Information</strong>
    <v-select
      :disabled="
        (order_status_id == 6 &&
          $store.state.permission.order.edit_view != 3) ||
        (order_status_id == 7 &&
          $store.state.permission.order.edit_view != 3) ||
        order_status_id == 0 ||
        isEditOrder
      "
      :items="status"
      v-model="order_detail.order_status"
      hide-details
      item-text="name"
      item-value="value"
      label="Status"
    ></v-select>
    <div class="text-xs-left mt-3">
      <v-layout row wrap>
        <v-flex xs6 style="position: relative; border-bottom: 1px solid">
          <v-text-field
            slot="activator"
            v-model="order_date.value"
            label="Order start date: "
            readonly
            hide-details
            :disabled="isEditOrder"
            v-if="
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder
            "
          ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="order_date_menu"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            class="mt-1"
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
          >
            <v-text-field
              slot="activator"
              v-model="order_date.value"
              label="Order start date: "
              readonly
              hide-details
            ></v-text-field>
            <v-date-picker
              :min="moment().format('YYYY-MM-DD')"
              v-model="order_date.value"
              color="#333"
              no-title
              @input="order_date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs5
          style="position: relative; border-bottom: 1px solid"
          class="ml-1"
        >
          <span
            style="font-size: 12px"
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
            >Order start time:</span
          >
          <v-text-field
            slot="activator"
            :value="order_time.value.HH + ':' + order_time.value.mm"
            label="Order start time"
            readonly
            hide-details
            v-if="
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder
            "
            :disabled="isEditOrder"
          ></v-text-field>
          <vue-timepicker
            hide-clear-button
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
            format="HH:mm"
            v-model="order_time.value"
            style="width: 100%"
          ></vue-timepicker>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-left mt-3">
      <v-layout row wrap>
        <v-flex xs6 style="position: relative; border-bottom: 1px solid">
          <v-text-field
            slot="activator"
            v-model="order_end_date.value"
            label="Order end date: "
            readonly
            hide-details
            v-if="
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder
            "
          ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="order_end_date_menu"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            class="mt-1"
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
          >
            <v-text-field
              slot="activator"
              v-model="order_end_date.value"
              label="Order end date: "
              readonly
              hide-details
            ></v-text-field>
            <v-date-picker
              :min="moment().format('YYYY-MM-DD')"
              v-model="order_end_date.value"
              color="#333"
              no-title
              @input="order_end_date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs5
          style="position: relative; border-bottom: 1px solid"
          class="ml-1"
        >
          <span
            style="font-size: 12px"
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
            >Order end time:</span
          >
          <v-text-field
            slot="activator"
            :value="order_end_time.value.HH + ':' + order_end_time.value.mm"
            label="Order end time"
            readonly
            hide-details
            v-if="
              (order_status_id == 6 &&
                $store.state.permission.order.edit_view != 3) ||
              (order_status_id == 7 &&
                $store.state.permission.order.edit_view != 3) ||
              isEditOrder
            "
          ></v-text-field>
          <vue-timepicker
            hide-clear-button
            v-if="
              (order_status_id != 6 && order_status_id != 7 && !isEditOrder) ||
              $store.state.permission.order.edit_view == 3
            "
            format="HH:mm"
            v-model="order_end_time.value"
            style="width: 100%"
          ></vue-timepicker>
        </v-flex>
      </v-layout>
    </div>
    <v-layout row class="mt-3">
      <v-flex xs6 class="mr-1">
        <!-- <v-select
          disabled
          :items="pay"
          v-model="order_detail.order_payment_type"
          item-text="name"
          item-value="value"
          hide-details
          label="Pay by"
        ></v-select>-->
        <div class="text-xs-left">
          <label class="field-disable-title">Pay by</label>
          <br />
          <div class="field-disable-data">
            {{
              order_detail.order_payment_type == 1
                ? "Cash"
                : order_detail.order_payment_type == 2
                ? "Credit card"
                : order_detail.order_payment_type == 3
                ? "PromptPay"
                : order_detail.order_payment_type == 4
                ? "Cryptocurrency"
                : order_detail.order_payment_type == 5
                ? "AR"
                : ""
            }}
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="ml-1">
        <!-- <v-select
          disabled
          :items="pay_status"
          v-model="order_detail.order_is_paymented"
          item-text="name"
          item-value="value"
          hide-details
          label="Pay status"
        ></v-select>-->
        <!-- {{order_detail.order_is_paymented}} -->
        <div class="text-xs-left">
          <label class="field-disable-title">Order area</label>
          <br />
          <div class="field-disable-data">
            {{ order_detail.order_districts_name }}
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="my-3" v-if="order_detail.order_payment_method == 2">
      <v-flex xs12 class="ml-1" style="display: flex">
        <span class="body__tag--pay_at_store">Pay at store</span>
      </v-flex>
    </v-layout>
    <!-- <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-text-field disabled slot="activator" label="Rider" readonly hide-details></v-text-field>
            </v-flex>
    <v-flex xs6 class="ml-2">-->

    <!-- </v-flex>
    </v-layout>-->
    <!-- <v-layout>
      <v-flex xs6 class="mr-2" style="position:relative;border-bottom:1px solid #757575">
    
        <v-text-field
          slot="activator"
          label="Order start date"
          readonly
          hide-details
          :value.sync="order_date"
          v-if="order_status_id == 6 || order_status_id == 7"
        ></v-text-field>
        <v-menu
          :close-on-content-click="false"
          v-model="menu2"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          v-if="order_date && order_status_id != 6 && order_status_id != 7"
        >
          <v-text-field
            slot="activator"
            :value.sync="order_date"
            label="Order start date"
            readonly
            hide-details
            clearable
          ></v-text-field>
          <v-date-picker @input="selectDate($event)" :value.sync="order_date" color="#333" no-title></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs6 class="text-xs-left" style="position:relative;border-bottom:1px solid #757575">
        <span
          style="font-size:12px;color:grey;top:5px;position:absolute;"
          v-if="order_status_id != 6 && order_status_id != 7"
        >Order start time</span>
        <v-text-field
          slot="activator"
          :value="order_time.HH + ':' + order_time.mm"
          label="Order start time"
          readonly
          hide-details
          v-if="order_status_id == 6 || order_status_id == 7"
        ></v-text-field>
        <vue-timepicker
          v-if="Object.keys(order_time).length != 0 && order_status_id != 6 && order_status_id != 7"
          format="HH:mm"
          @input="$emit('setOrderTime',$event)"
          :value.sync="order_time"
          style="top:17px;position:absolute;left:0px;width:262px;"
        ></vue-timepicker>
      </v-flex>
    </v-layout>-->
    <storeInformation
      :order_detail_position="order_detail.order_position"
      v-for="(info, index) in order_detail.order_store"
      :key="info.store_id"
      :info="info"
      :index="index"
      :transfer_time="transfer_time"
      :transfer_date="transfer_date"
      @viewIMG="$emit('viewIMG', $event)"
    />

    <v-layout row wrap>
      <v-flex xs12 class="mt-3">
        <v-textarea
          v-if="order_status_id != 6 && order_status_id != 7"
          :disabled="
            (order_status_id == 6 &&
              $store.state.permission.order.edit_view != 3) ||
            (order_status_id == 7 &&
              $store.state.permission.order.edit_view != 3) ||
            isEditOrder
          "
          v-model="order_detail.order_transfer_note"
          hide-details
          rows="2"
          label="Note to rider :"
        ></v-textarea>
        <div
          class="text-xs-left"
          v-if="
            (order_status_id == 6 &&
              $store.state.permission.order.edit_view != 3) ||
            (order_status_id == 7 &&
              $store.state.permission.order.edit_view != 3)
          "
        >
          <label class="field-disable-title">Note to rider :</label>
          <br />
          <div class="field-disable-data">
            {{ order_detail.order_transfer_note }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-textarea
          v-model="order_detail.order_note"
          :disabled="isEditOrder || order_detail.order_status == 7"
          hide-details
          rows="2"
          label="Admin note :"
        ></v-textarea>
        <!-- <div class="text-xs-left" v-if="order_status_id == 7">
          <label class="field-disable-title">Admin note :</label>
          <br>
          <div class="field-disable-data">{{order_detail.order_note}}</div>
        </div>-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import storeInformation from "./Transfer/StoreInformation.vue";
import { mapState, mapGetters } from "vuex";
export default {
  props: [
    "order_detail",
    "order_date",
    "order_time",
    "order_end_time",
    "order_end_date",
    "transfer_time",
    "transfer_date",
  ],
  data() {
    return {
      order_end_date_menu: false,
      order_date_menu: false,
      menu2: false,
      status: [
        { name: "Order made", value: 1 },
        { name: "In queue", value: 2 },
        { name: "Cooking", value: 3 },
        { name: "Ready to pick up", value: 4 },
        { name: "On the way", value: 5 },
        { name: "Completed", value: 6 },
      ],
      pay: [
        { name: "Cash", value: 1 },
        { name: "Credit card", value: 2 },
      ],
      pay_status: [
        { name: "Paid", value: 2 },
        { name: "Not pay", value: 1 },
      ],
    };
  },
  components: {
    VueTimepicker,
    storeInformation,
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
  },
  methods: {
    selectDate(event) {
      this.$emit("setOrderDate", event);
      this.menu2 = false;
    },
  },
};
</script>

<style scoped>
.body__tag--pay_at_store {
  background-color: red;
  font-size: 18px;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
}
.field-disable-title {
  color: #9e9e9e;
  font-size: 12px;
}
.field-disable-data {
  color: #9e9e9e;
  font-size: 16px;
}
</style>
